// Short control-room alert tones, synthesised with the Web Audio API so
// there's no asset to load. Browsers gate audio behind a user gesture — the
// context unlocks on the dispatcher's first interaction with the page, so at
// worst the very first alert after a fresh page load is silent.
let audioContext = null

const playNotes = (notes, peakGain = 0.2, noteLength = 0.3) => {
  try {
    audioContext =
      audioContext ||
      new (window.AudioContext || window.webkitAudioContext)()
    if (audioContext.state === 'suspended') {
      audioContext.resume().catch(() => {})
    }

    const now = audioContext.currentTime
    notes.forEach(([frequency, offset]) => {
      const oscillator = audioContext.createOscillator()
      const gain = audioContext.createGain()
      oscillator.type = 'sine'
      oscillator.frequency.value = frequency
      gain.gain.setValueAtTime(0.0001, now + offset)
      gain.gain.exponentialRampToValueAtTime(peakGain, now + offset + 0.02)
      gain.gain.exponentialRampToValueAtTime(
        0.0001,
        now + offset + noteLength,
      )
      oscillator.connect(gain)
      gain.connect(audioContext.destination)
      oscillator.start(now + offset)
      oscillator.stop(now + offset + noteLength + 0.02)
    })
  } catch (_error) {
    // Audio unavailable — the visual indicators still notify
  }
}

// Ascending pair: a crew message arrived
export const playChatPing = () =>
  playNotes([
    [880, 0],
    [1174.66, 0.12],
  ])

// Single "ding" (C5 with its octave for body): an incident's own timeline
// gained an entry — status change, update, crew movement.
export const playIncidentLogPing = () =>
  playNotes(
    [
      [523.25, 0],
      [1046.5, 0],
    ],
    0.34,
    0.35,
  )

// Rising double ding (G5 → C6, each with its lower octave for body): a new
// non-incident entry appeared in the room log feed. Pitched apart from the
// crew-chat ping (A5 → D6) so the two are distinguishable; loud enough to
// carry across a control room, but two short tones — nothing like the
// incident alarm.
export const playLogPing = () =>
  playNotes(
    [
      [392.0, 0],
      [783.99, 0],
      [523.25, 0.16],
      [1046.5, 0.16],
    ],
    0.34,
    0.3,
  )

// Descending pair, a touch longer: a crew acknowledged a stand-down
export const playStandDownAck = () =>
  playNotes(
    [
      [1174.66, 0],
      [783.99, 0.16],
    ],
    0.22,
    0.45,
  )
